module.exports = __webpack_public_path__ + "static/media/graphicDesign.93958b24.png";